// extracted by mini-css-extract-plugin
export default {"quantitySelector":"QuantitySelector_quantitySelector__Vj-yc","btn":"QuantitySelector_btn__aCczR"};